export default __webpack_public_path__ + "static/wunschpiercing-3-33f3b9137898aedc8b1fc71fa27a3900.jpg";